import { Subscription, Unsubscribable } from 'rxjs';

export class WindowHelper {
  public static getBaseUrlClient() {
    return window.location.protocol + '//' + window.location.host + '/';
  }

  public static fixFontSize(): Unsubscribable {
    // em is based on the font-size of the body element
    // this correctly adjusts prime ng controls that use em and rem
    const oldFontSize = document.documentElement.style.fontSize;
    document.documentElement.style.fontSize = '14px';
    return new Subscription(() => {
      document.documentElement.style.fontSize = oldFontSize;
    });
  }

  public static openUrlInNewTab(url: string) {
    window.open(url, '_blank');
  }
}
